import * as THREE from 'three';
import BaseMesh from '../BaseMesh.js';
import { TextTexture } from './TextTexture';

class Index extends BaseMesh {
  constructor(data) {
    super(data);
    // const { text, color, border, fontSize = 20, padding = 10, opacity = 1, backgroundColor = 'white' } = this.props;
    // const textOptions = {
    //   text: text,
    //   fontSize: fontSize,
    //   color: color,
    //   backgroundColor: backgroundColor,
    //   padding: padding,
    //   border
    // };
    const { opacity = 1 } = this.props;
    const { url, width, height } = new TextTexture(this.props);

    this.geometry = new THREE.PlaneGeometry(width, height);
    const texture = new THREE.TextureLoader().load(url);
    // 去除黑边
    texture.minFilter = THREE.NearestFilter;
    texture.magFilter = THREE.NearestFilter;
    this.material = new THREE.MeshBasicMaterial({
      map: texture,
      side: THREE.FrontSide,
      transparent: true,
      depthTest: false,
      opacity,
    });
  }
  updateProps(key, value) {
    super.updateProps(key, value);
    switch (key) {
      case 'static':
        break;
      case 'text':
        this.props[key] = value;
        const { url } = new TextTexture(this.props);
        this.material.map = new THREE.TextureLoader().load(url);
        break;
      case 'opacity':
        this.material.opacity = value;
        break;
    }
  }

  setProps(props) {
    super.setProps(props);
    const { opacity = 1 } = props;
    const { url, width, height } = new TextTexture(props);
    this.geometry = new THREE.PlaneGeometry(width, height);
    this.material = new THREE.MeshBasicMaterial({
      map: new THREE.TextureLoader().load(url),
      side: THREE.FrontSide,
      transparent: true,
      depthTest: false,
      opacity
    });
  }
}

export default Index;
